import React from "react";
import { Archive, Clock } from "lucide-react";

// Sprint 8.E — Read-Only-Banner für cancelled User auf /cockpit und in SavedLibrary.
// Zeigt Status + Countdown bis Anonymisierung + Reaktivierungs-CTA.

export default function ReadOnlyBanner({ retention, onReactivate }) {
  if (!retention?.cancelled || !retention?.read_only) return null;
  const days = retention.days_remaining ?? 0;
  const cancelledAt = (retention.cancelled_at || "").slice(0, 10);

  return (
    <div
      data-testid="readonly-banner"
      className="mb-5 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 flex items-start sm:items-center gap-3 flex-col sm:flex-row"
    >
      <Archive className="w-5 h-5 text-amber-600 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-amber-900">
          Read-Only-Modus · Deine Flexpfad-Bibliothek ist archiviert.
        </p>
        <p className="mt-0.5 text-xs text-amber-800 flex flex-wrap gap-x-3 gap-y-0.5">
          {cancelledAt && <span>Gekündigt am {cancelledAt}</span>}
          <span className="inline-flex items-center gap-1">
            <Clock className="w-3 h-3" />
            <span data-testid="readonly-days-remaining">
              Daten noch <strong>{days} Tag{days === 1 ? "" : "e"}</strong> verfügbar
            </span>
          </span>
        </p>
      </div>
      {onReactivate && (
        <button
          type="button"
          onClick={onReactivate}
          data-testid="readonly-banner-reactivate"
          className="rounded-md bg-amber-600 hover:bg-amber-700 text-white px-3 py-1.5 text-xs font-bold whitespace-nowrap"
        >
          Reaktivieren →
        </button>
      )}
    </div>
  );
}
